import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import _ from "lodash";
import { flattenArrayDeep } from "@/utils/utils";
import { showNocifaction } from "@/utils/commonNotifaction";
import { message } from "ant-design-vue";
import {
  getGroupTree,
  getGroupTreeSn,
  getHistoryData,
  getGfSnData,
  getAlarmTypeList,
  getStationList,
  getTaskType,
  getOperationUserList
} from "@/api/api";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    authUserInfo: null,
    clientInfo: {},
    userMenuPower: { menu: {}, controls: {} },
    sensortypes: [
      { value: "pm10", label: "PM₁₀", unit: "μg/m³", decimal: 0 },
      { value: "pm25", label: "PM₂.₅", unit: "μg/m³", decimal: 0 }
    ],
    lang: "zh",
    siderCollapsed: false,
    mapTheme: "amap://styles/normal",
    hideHeader: false, //控制头部显示隐藏
    hideLeftMenu: false, //控制左侧菜单栏显示隐藏
    setType: "fixedPeriod",
    mapType: false,
    // 图层叠加
    projectInfo: null,
    pageTitle: "",
    groupTree: [],
    groupTreeSn: [],
    checkedHistoryStationIds: [],
    checkedGfStationIds: [],
    historyData: [],
    gfSnData: [],
    appSelection: [],
    region: [],
    alarmTypeList: [],
    stationList: [],
    taskTypeList: [],
    operationUserList: [],
    colorRange: [0, 700]
  },
  mutations: {
    updateTitle(state, data) {
      state.pageTitle = data;
    },
    updateWindowInfoShow(state, data) {
      state.showGigWindow = data;
    },
    updateWindowInfo(state, data) {
      state.windowInfo = data;
    },
    updateHideHeader(state, data) {
      state.hideHeader = data;
    },
    updateHideLeftMenu(state, data) {
      state.hideLeftMenu = data;
    },
    // 设置地图主题
    setMapTheme(state, theme) {
      state.mapTheme = theme;
    },
    setMapType(state, v) {
      state.mapType = v;
    },
    setToken(state, token) {
      state.token = token;
    },
    setClientInfo(state, data) {
      state.clientInfo = data;
    },
    setProjectInfo(state, data) {
      state.projectInfo = data;
    },
    setAuthUserInfo(state, data) {
      state.authUserInfo = data;
    },
    getUserMenuPower(state, data) {
      let controls_array = data.controls || [];
      let menus = data.menus || [];
      if (!menus.length) {
        message.info("用户无菜单权限，请联系管理员配置");
      }
      let controls = {};
      for (let i of controls_array) {
        controls[i.name] = 1;
      }
      data.controls = controls;
      state.userMenuPower = data;
    },
    updateLang(state, data) {
      state.lang = data;
    },
    updateSiderCollapsed(state, data) {
      state.siderCollapsed = data;
    },
    setSensorTypes(state) {
      let projectSensorTypes = state.projectInfo.sensorType;
      if (state.authUserInfo?.userExtraInfo?.sensorType) {
        projectSensorTypes = state.authUserInfo.userExtraInfo.sensorType;
      }
      if (!projectSensorTypes) {
        projectSensorTypes = "pm10,pm25";
      }

      if (state.userMenuPower.controls.internalSensorTypes) {
        let internalSensorTypes =
          state.authUserInfo?.extraInfo?.projectSetting?.internalSensorTypes;
        if (internalSensorTypes) {
          projectSensorTypes += `,${internalSensorTypes}`;
        }
      }
      let sensortypes = [];
      let typeStrs = projectSensorTypes.split(",");
      state.projectInfo.sensorType = projectSensorTypes;
      for (let t of typeStrs) {
        let info = G_SENSOR_DATA_TYPE_INFO.find(x => x.value === t);
        if (info) {
          sensortypes.push(info);
        }
      }
      state.sensortypes = sensortypes;
    },
    setSetType(state, value) {
      state.setType = value;
    },
    updateGroupTree(state, tree) {
      state.groupTree = tree;
    },
    updateGroupTreeSn(state, value) {
      state.groupTreeSn = [
        {
          station: "标站",
          children: value
        }
      ];
    },
    updateCheckedHistoryStationIds(state, value) {
      state.checkedHistoryStationIds = value;
    },
    updateCheckedGfStationIds(state, value) {
      state.checkedGfStationIds = value;
    },
    setHistoryData(state, value) {
      state.historyData = value;
    },
    setGfSnData(state, value) {
      state.gfSnData = value;
    },
    SetAppSelection(state, value) {
      state.appSelection = value;
    },
    setRegion(state, value) {
      state.region = value;
    },
    setAlarmTypeList(state, value) {
      state.alarmTypeList = value;
    },
    setStationList(state, value) {
      state.stationList = value;
    },
    setTaskTypeList(state, value) {
      state.taskTypeList = value;
    },
    setOperationUserList(state, value) {
      state.operationUserList = value;
    },
    setColorRange(state, v) {
      state.colorRange = v;
    }
  },
  getters: {
    defaultInfo: state => {
      const defaultSensorType = state.sensortypes[0].value;
      let defaultGroupId = "";
      if (state.authUserInfo?.devGroupIds) {
        defaultGroupId = state.authUserInfo.devGroupIds.split(",")[0];
      } else {
        defaultGroupId = state.projectInfo.defaultDevGroup;
      }
      return {
        defaultSensorType,
        defaultGroupId,
        // 地图边界轮廓颜色，根据地图样式动态变化
        borderColor: state.mapTheme == "amap://styles/grey" ? "white" : "red"
      };
    },
    region: state => state.region
  },
  actions: {
    async init({ state, commit, dispatch }) {
      // showNocifaction();
      commit("setSensorTypes");
      await dispatch("getGroupTree");
      // await dispatch("getGroupTreeSn");
      await dispatch("getAlarmTypeList");
      await dispatch("getOperationUserList");
    },
    getGroupTree(context) {
      context.commit("updateGroupTree", []);
      return getGroupTree(context.getters.defaultInfo.defaultGroupId).then(
        r => {
          return context.commit("updateGroupTree", r.data);
        }
      );
    },
    getGroupTreeSn(context) {
      return getGroupTreeSn(context.state.projectInfo.regionId)
        .then(res => {
          const data = res.data.data;
          return context.commit("updateGroupTreeSn", data);
        })
        .catch(err => console.log(err));
    },
    async getHistoryData(context, obj) {
      const sensortypes = context.state.sensortypes.map(x => x.value).join(",");
      let start = moment(obj.dateRange[0]).format("YYYY-MM-DD HH:mm:ss");
      let end = moment(obj.dateRange[1]).format("YYYY-MM-DD HH:mm:ss");
      let historyData = [];
      let group_id = context.getters.defaultInfo.defaultGroupId;
      const flattenTreeArr = flattenArrayDeep(context.state.groupTree);
      let checked_station_info_list = [];
      for (let station_id of context.state.checkedHistoryStationIds) {
        let station_info = {};
        station_info = flattenTreeArr.find(x => x.id == station_id);
        if (!station_info) {
          continue;
        }
        checked_station_info_list.push(station_info);
      }
      if (checked_station_info_list.length) {
        try {
          let station_ids = checked_station_info_list.map(x => x.id).join(",");
          let res = await getHistoryData(
            group_id,
            station_ids,
            obj.timeType,
            sensortypes,
            start,
            end
          );

          const aggregatedData = {};
          let columns = res.data.data.columns;
          let data = res.data.data.data;
          data.forEach(item => {
            item[0] = item[0] * 1000;
            const id = item[1];
            if (aggregatedData.hasOwnProperty(id)) {
              aggregatedData[id].push(item);
            } else {
              aggregatedData[id] = [item];
            }
          });
          for (const id in aggregatedData) {
            let station = [];
            station = flattenTreeArr.filter(x => x.id == id);
            historyData.push({
              type: "history",
              station,
              columns,
              id,
              datas: aggregatedData[id]
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
      return context.commit("setHistoryData", historyData);
    },
    async getGfSnData(context, obj) {
      const sensortypes = context.state.sensortypes.map(x => x.value).join(",");
      let timeType = ["sec", "min"].includes(obj.timeType)
        ? "hour"
        : obj.timeType;
      const start_t = moment(obj.dateRange[0]).format("YYYY-MM-DD HH:mm:00");
      const end_t = moment(obj.dateRange[1]).format("YYYY-MM-DD HH:mm:00");
      let checkedGfStationIds = context.state.checkedGfStationIds;
      let groupTreeSn = context.state.groupTreeSn?.[0]?.children || [];
      let gfSnData = [];
      for (let id of checkedGfStationIds) {
        try {
          let item = groupTreeSn.find(x => x.id == id);
          let res = await getGfSnData(
            item.sn,
            start_t,
            end_t,
            sensortypes,
            timeType
          );
          let dataobj = res.data.data;
          let { sn, data, fields } = dataobj;
          for (let d of data) {
            d[0] = d[0] * 1000;
          }
          data = data.sort((a, b) => a[0] - b[0]);
          gfSnData.push({
            type: "snCombine",
            station: [{ DevSN: sn, Id: item.id, Name: item.station }],
            columns: fields,
            id: item.id,
            datas: data
          });
        } catch (error) {
          console.log(error);
        }
      }
      return context.commit("setGfSnData", gfSnData);
    },
    // 获取报警类型
    getAlarmTypeList({ commit }) {
      return getAlarmTypeList()
        .then(res => {
          commit("setAlarmTypeList", res.data.items);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 获取所有站点列表
    getStationList({ commit, getters }) {
      return getStationList({ group_id: getters.defaultInfo.defaultGroupId })
        .then(res => {
          commit("setStationList", res.data.items);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 获取任务类型
    getTaskTypeList({ commit }) {
      return getTaskType()
        .then(res => {
          commit("setTaskTypeList", res.data.data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 获取运维人员列表
    getOperationUserList({ commit, getters }) {
      return getOperationUserList({
        group_id: getters.defaultInfo.defaultGroupId
      })
        .then(res => {
          commit("setOperationUserList", res.data.items);
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }
});
